import { IVoucherType } from '../interfaces/IVoucherType';

export function isFixedAmountTrackOnlyExternal(voucherType: IVoucherType): boolean {
  if (
    voucherType.flagInternal ||
    voucherType.flagAcardo ||
    voucherType.flagDistributor ||
    voucherType.keyExternalApi ||
    voucherType.flagGroup ||
    voucherType.isSeries ||
    voucherType.flagIdentifiable ||
    voucherType.flagValueTicket
  ) {
    return false;
  }

  return voucherType.flagVariable || voucherType.amountMin > 0;
}
